import * as React from "react";
import { Grid, Menu, Card, Loader, Divider, Segment, Button } from "semantic-ui-react";

import { Detail } from "@neworbit/simpleui-detail";
import { useSelector } from "react-redux";

import { teamSelector, basePathSelector } from "../selectors";
import { ApplicationState } from "../../../applicationState";

import { Link } from "redux-little-router";

export const Details = () => {
    const team = useSelector(teamSelector);
    const path = useSelector((state: ApplicationState) => state.router.pathname);
    const basePath = useSelector(basePathSelector);
    if (team === undefined) {
        return <Loader active />;
    }

    return (
        <Grid container className="nomargintop">
            <Grid.Row>
                <Grid.Column>
                    <h1>{team.name}</h1>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width={3} as={Grid} padded>
                    <Grid.Column vertical as={Menu}>
                        <Menu.Item name="Teams" as={Link} href={basePath}>
                            All Customer Teams
                        </Menu.Item>
                    </Grid.Column>
                </Grid.Column>

                <Grid.Column width={13}>
                    <Card fluid>
                        <Grid>
                            <Detail label="Name" value={team.name} labelWidth={5} valueWidth={11} />
                            <Detail
                                label="Members"
                                value={team.members.map(member => member.name).join(", ")}
                                labelWidth={5}
                                valueWidth={11}
                            />
                        </Grid>
                        <Divider />
                        <Segment basic clearing vertical>
                            <Button icon="pencil" content="Edit" floated="right" as={Link} href={`${path}/edit`} />
                        </Segment>
                    </Card>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
};
